export const selectCars = store => store.cars.cars;
export const selectFavoriteCars = store => store.cars.favorite;
export const selectIsLastPage = store => store.cars.isLastPage;
